import { Text } from "@mantine/core";
import { isNumber } from "@tiptap/react";
import { type ILogbook } from "src/interfaces";

import { getStatusValue } from "../../components/pages/Summary/ReviewsAndAudits/RevAud.utils";
import { StatusGoldCircle } from "../../components/pages/Summary/ReviewsTable/ReviewsTable.styled";
import { entryStatusMap, mapLogbookSelect } from "../../utils";
import { type ISummaryItem } from "./Summary.types";
import type { ComboboxData } from "@mantine/core";

interface IStatus {
  status: string;
  color: string;
  fontWeight: string;
}

export const summaryStatusList: Readonly<Record<number, Readonly<IStatus>>> =
  Object.fromEntries(
    Object.entries(entryStatusMap).map(([code, { summary }]) => [
      code,
      { status: summary.label, color: summary.color, fontWeight: summary.fontWeight },
    ]),
  );

export const rStatusList: Record<number, IStatus> = {
  0: { status: "Pending", color: "yellow.6", fontWeight: "bold" },
  1: { status: "Action Required", color: "red.8", fontWeight: "bold" },
  10: { status: "Completed", color: "blue.5", fontWeight: "bold" },
};

export const mapSummary = (data: any) => {
  const auditor = data?.data?.auditor;
  const nonauditor = data?.data?.nonauditor;
  const expired = data?.data?.review?.audit?.expired;
  const yachtuser = data?.data?.yachtuser;
  const audit = data?.data?.review?.audit;
  const pages = data.data.review.pages;
  const reviews: ISummaryItem[] =
    data.data.review?.data?.map((review: any) => {
      let comments = review.comments ?? [];
      if (typeof comments === "string") comments = JSON.parse(comments);
      return { ...review, comments };
    }) ?? [];
  const required: ISummaryItem[] =
    data.data.review?.required?.map((review: any) => {
      let comments = review.comments ?? [];
      if (typeof comments === "string") comments = JSON.parse(comments);
      return { ...review, comments };
    }) ?? [];

  const logbooks: ComboboxData = mapLogbookSelect(data.data.review.logbooks);

  let comments = data?.data?.review?.audit?.data?.comments;
  if (typeof comments === "string") comments = JSON.parse(comments);
  return {
    reviews,
    required,
    logbooks,
    pages,
    comments,
    audit,
    yachtuser,
    expired,
    nonauditor,
    auditor,
  };
};

export const renderAuditName = (status: number) => {
  const getName = () => {
    switch (status) {
      case 1000:
        return "Audit";
      case 240:
        return "Managment Review";
      case 250:
        return "Yacht Review";
    }
  };

  return (
    <Text size="xs" c="main.4">
      {getName()}
    </Text>
  );
};
export const renderStatusBadge = (type: number) => {
  return <StatusGoldCircle>{getStatusValue(type)}</StatusGoldCircle>;
};